<template>
  <v-container>
    <v-layout>
    <v-flex>
      <v-tooltip top >
      <v-btn
          class="mr-2 mb-2"
          @click="newCatalog"
          color="customPurple"
          dark
          fixed
          bottom
          right
          fab
          slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Catálogo</span>
    </v-tooltip>
      <div>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false" @click="cleanData">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crear nuevo catálogo</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout>
                <v-flex xs12 sm7 offset-sm1>
                  <v-text-field
                    name="codigo"
                    label="Código"
                    id="code"
                    :rules="[v => !!v || 'El código es requerido', v => (v && v.length <= 10) || 'El código debe tener menos de 10 caracteres']"
                    required
                    v-model="catalog.code"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="nombre"
                    label="Nombre"
                    id="nombre"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                    v-model="catalog.name"
                    required
                    v-on:keyup.enter="saveData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                <v-select
                  :items="items"
                  v-model="catalog.type"
                  label="Seleccione Tipo de Catálogo"
                ></v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-select
                    :items="$store.state.catalogs"
                    v-model="catalogParent"
                    label="Seleccione un Catálogo Padre"
                    single-line
                    :hint="`${catalogParent.id}, ${catalogParent.name}`"
                    item-text="name"
                    item-value="id"
                    :rules="[v => !!v || 'Campo requerido']"
                    return-object
                    persistent-hint
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-switch
                    label="Inactivo / Activo"
                    v-model="catalog.enabled"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                  <div>
                    <v-btn :disabled="!valid"
                           @click="saveData" large color="primary">Guardar</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-layout>
       <h3 class="primary--text">Lista de Catálogos</h3>
      <v-data-table
        :headers="headers"
        :items="$store.state.catalogs"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.type }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.code }}</td>
          <td class="text-xs-left">{{ getCatalogParentIdName(props.item.catalogueItemId)}}</td>
          <td class="text-xs-left">{{ props.item.enabled?"Activo":"Inactivo" }}</td>
          <td>
            <v-tooltip top >
              <v-btn 
              fab dark 
              small @click="editItem(props.item)" 
              slot="activator"
              color="primary">
              <v-icon dark>edit</v-icon>
            </v-btn>
            <span>Editar</span>
            </v-tooltip>
            <v-tooltip top >
              <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                <v-icon dark>delete</v-icon>
              </v-btn>
            <span>Eliminar</span>
            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>
import Catalog from '../../model/Catalog';

export default {
  data() {
    return {
      search: '',
      valid: false,
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      headers: [
        { text: 'Tipo', value: 'type' },
        { text: 'Nombre', value: 'name' },
        { text: 'ID', value: 'id' },
        { text: 'Código', value: 'code' },
        { text: 'Catálogo Padre', value: 'catalogueItemId' },
        { text: 'Estado', value: 'estado' },
        { text: 'Acciones', value: 'editar' },
      ],
      items: ['TIPO_DOCUMENTO'],
      editedIndex: -1,
      catalog: new Catalog(),
      catalogParent: new Catalog()
    };
  },
  methods: {
    cleanData() {
      this.$refs.form.reset();
      this.catalog = new Catalog();
      this.catalogParent = new Catalog();
      this.valid = false;
      this.dialog = false;
    },
    newCatalog() {
      this.editedIndex = -1;
      this.valid = false;
      this.dialog = true;
      this.$refs.form.reset();
      this.catalog = new Catalog();
      this.catalogParent = new Catalog();
    },
    saveData() {
      if (this.$refs.form.validate()) {
        this.catalog.catalogueItemId = this.catalogParent.id;
        if (this.editedIndex > -1) {
          this.$store.dispatch('updateCatalog', this.catalog).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        } else {
          this.$store.dispatch('addCatalog', this.catalog).then(
            response => {
              this.cleanData();
            },
            error => {
              this.$store.state.progress = false;
              this.$store.state.dialogError = true;
            }
          );
        }
        this.dialog = false;
      }
    },
    editItem(item) {
      this.editedIndex = this.$store.state.catalogs.indexOf(item);
      this.catalog = Object.assign({}, item);
      for (var i = 0; i < this.$store.state.catalogs.length; i++) {
        this.catalogParent = this.$store.state.catalogs[i];
        var hasCatalogParent = false;
        if (this.catalogParent.id === this.catalog.catalogueItemId) {
          hasCatalogParent = true;
          break;
        }
        if (!hasCatalogParent) {
          this.catalogParent = {
            id: '',
            code: '',
            name: '',
            enabled: '',
            catalogueItemId: ''
          };
        }
      }
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.$store.state.catalogs.indexOf(item);
      this.catalog = Object.assign({}, item);
      confirm('Está seguro de que quiere eliminar el registro?') &&
        this.$store.dispatch('deleteCatalog', this.catalog.id);
    },
    getCatalogParentIdName(id) {
      for (var i = 0; i < this.$store.state.catalogs.length; i++) {
        if (this.$store.state.catalogs[i].id === id) {
          return id + ' - ' + this.$store.state.catalogs[i].name;
        }
      }
    }
  },
  computed: {},
  beforeCreate() {
    this.$store.dispatch('getCatalogs').then(
      response => {
        this.cleanData();
      },
      error => {
        this.$store.state.dialogError = true;
      }
    );
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/catalog/Catalog.vue